<template>
    <Card
        :size="`col-md-10 col-lg-8 col-xl-6 max-xl-670`"
        :modifiers="`py-5`"
    >
        <template slot="card-header">
            <h1 v-translate>Welcome Back</h1>
            <p v-translate="{ first_name: first_name }">Hello %{ first_name }, where would you like to go next?</p>
        </template>
        <template slot="card-body">
            <div class="text-center">
                <a
                    href="#"
                    class="btn btn-primary"
                    @click.prevent="logout"
                    v-translate
                >Logout</a>
                <a
                    href="#"
                    class="btn btn-primary"
                    @click.prevent="completeProxy"
                    :disabled="loading.submit"
                >
                    <span v-if="go_to_smartcharts && !loading.submit">{{ proceedText }}</span>
                    <template v-else-if="loading.submit">
                        <div class="loader">
                            <loader
                                :width="15"
                                :height="15"
                            />
                        </div>
                    </template>
                    <span
                        v-else
                        v-translate
                    >Proceed To LMS</span>
                </a>
            </div>
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <flash-message></flash-message>
                </div>
            </div>
        </template>
    </Card>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Card from '@C/Card';
import FlashMessage from '@C/FlashMessage';

export default {
    name: 'landing',
    data() {
        return {
            loading: {
                submit: false
            }
        }
    },
    methods: {
        ...mapActions({
            logout: 'Auth/logout',
            complete: 'Enrolment/complete'
        }),
        async completeProxy() {
            this.loading.submit = true;

            try {
                await this.complete();
            } catch (err) {
                this.loading.submit = false;
            }
        }
    },
    computed: {
        ...mapState('Auth', ['first_name', 'go_to_smartcharts']),
        sandbox_mode: function () {
            return window.sandbox_mode;
        },
        proceedText: function () {
            return this.$gettextInterpolate('Proceed to %{ appName }', {
                appName: window.appName,
            });
        },
    },
    components: {
        Card,
        FlashMessage
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/Landing.vue